(ns pfo.state
  (:require [reagent.core :as reagent :refer [atom]]
            [alandipert.storage-atom :refer [local-storage]]
            [amalloy.ring-buffer :refer [ring-buffer]]
            [clojure.string :as str]
            [cljs-uuid-utils.core :as uuid]))

(def current-page (atom [:div]))

(def catom clojure.core/atom)

(def use-local-auth-state (catom false))

(def auth-service-provider (atom nil))

(def auth-url (atom "/authenticate/"))

(def ui-id (uuid/uuid-string (uuid/make-random-uuid)))

(def sidebar-active (atom true))

(def include-descendants (atom true))

(def collection-tree-modal (atom {:enabled false}))

(def document-preview-modal (atom {:enabled false}))

(def menu-modal (atom {:enabled false}))

(def document-add-modal (atom {:enabled false}))

(def task-add-modal (atom {:enabled false}))

(def step-sign-auth-modal (atom {:enabled false}))

(def compliance-edit-conflicts-modal (atom {:enabled false}))

(def confirmation-modal (atom {:enabled false}))

(def action-modal (atom {:enabled false}))

(def template-copy-modal (atom {:enabled false}))

(def controled-confirmation-modal (atom {:enabled false}))

(def modals (atom {}))

(def flash (atom {:active false}))

(def permission-types (local-storage (atom #{}) :permission-types))

(def family-permissions (local-storage (atom #{}) :group-permissions))
(def ^:deprecated group-permissions family-permissions)

(def subscriber-admin (local-storage (atom nil) :subscriber-admin))

(def can-review-documents (local-storage (atom false) :can-review-documents))

(def is-novice (local-storage (atom false) :is-novice))

(def family-settings (local-storage (atom nil) :family-settings))

(def display-collection-nav (atom false))

(def events-list-show (atom false))

(def infobox (atom nil))

(def collection-family (atom {}))

(def chart-recent (local-storage (atom {}) :chart-recent))

(def alert-count-recent (local-storage (atom {:value 0}) :alert-count-recent))

;; nav states
(def recent-parent-ids (atom [nil]))
(def recent-selected-child (atom {}))
(def recent-parent-children (atom {}))
(def parent-id-filter-map (local-storage (atom {}) :collection-filters))

(def loading-count (clojure.core/atom 0))

(def ui-state (clojure.core/atom {}))

(def last-collection-details-id (clojure.core/atom nil))

; Why 10? It's conceivable that multiple objects will be deleted (return to parent, return to parent, etc...)
; Need more than one return-after-delete waypoint, so why not ten?
(def nav-state (atom (ring-buffer 10)))

(defn add-nav-state [states state]
  (if (= (:tag-name state) (:tag-name (last states)))
    (conj (vec (butlast states)) state)
    (conj states state)))

(defn update-last-nav-state [states state]
  (let [last-state (last states)]
    (conj (vec (butlast states)) (merge last-state state))))

(defn remove-last-nav-state [states]
  (vec (butlast states)))

(defn nav-state-current-area []
  (let [last-nav-state (last @nav-state)
        last-sub-tag-nav-state (last (filter #(not-empty (:sub-tag-name %)) @nav-state))
        state-tag (:tag-name last-nav-state)
        area-name (when state-tag
                    (->
                      (name state-tag)
                      (str/split #"-")
                      first))
        state-sub-tag (if (:sub-tag-name last-nav-state)
                        (:sub-tag-name last-nav-state)
                        (when (= "task" area-name)
                          (:sub-tag-name last-sub-tag-nav-state)))]
    (when state-tag (keyword (str area-name (when state-sub-tag (str "-" state-sub-tag)))))))

(def last-nav-tag-name (atom nil))

(def force-mobile-menu (atom false))

(def nav-flow (atom (ring-buffer 2)))

(defn add-nav-flow [flows flow]
  (if-not (= (:location flow) (:location (last flows)))
    (conj flows flow)
    flows))

(def task-tabs-active (atom :all))
